<template>
    <report id="cta-personal">
        <page>
            <cover-page
                :reportType="$t(`reportsWeb.REPORT_TYPE`)"
                :firstName="reportData.firstName"
                :lastName="reportData.lastName"
                :date="dateCompleted"
            />
        </page>

        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.INTRODUCTION_TITLE') }}</survey-title>

                <div v-html="sanitizeHtml($t(`reportsWeb.INTRODUCTION_TEXT`))"></div>
            </div>

            <div class="cta-summary">
                <h2>{{ $t('reportsWeb.SUMMARY_TITLE') }}</h2>
                <div class="cta-summary-pages" v-html="sanitizeHtml($t(`reportsWeb.SUMMARY_TEXT`))"></div>
            </div>
        </page>

        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.METHOD_TITLE') }}</survey-title>
                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_TEXT`))"></div>

                <div class="extended-domain-wrapper">
                    <div class="extended-domain-action-wrapper">
                        <h2>{{ $t('reportsWeb.ACTION_DOMAIN_TITLE') }}</h2>

                        <p>{{ $t('reportsWeb.ACTION_DOMAIN_TEXT') }}</p>

                        <div class="extended-action-domain">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Move.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_MOVE`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Follow.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_FOLLOW`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Oppose.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_OPPOSE`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Bystand.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_BYSTAND`))"></div>
                            </div>
                        </div>
                    </div>

                    <div class="extended-domain-operating-wrapper">
                        <h2>{{ $t('reportsWeb.OPERATING_DOMAIN_TITLE') }}</h2>

                        <p>{{ $t('reportsWeb.OPERATING_DOMAIN_TEXT') }}</p>

                        <div class="extended-domain-operating">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Closed.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_CLOSED`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Open.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_OPEN`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Random.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_RANDOM`))"></div>
                            </div>
                        </div>
                    </div>

                    <div class="extended-domain-attention-wrapper">
                        <h2>{{ $t('reportsWeb.ATTENTION_DOMAIN_TITLE') }}</h2>

                        <p>{{ $t('reportsWeb.ATTENTION_DOMAIN_TEXT') }}</p>

                        <div class="extended-domain-attention">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Affect.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_AFFECT`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Meaning.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_MEANING`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Power.svg" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_POWER`))"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_TEXT_OUTRO`))"></div>
            </div>
        </page>

        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.PROFILE_TITLE') }}</survey-title>
                <div>
                    <div class="chart-wrapper" style="margin-top: 2rem">
                        <CtaSunburstChart
                            :chartId="98"
                            :domainArray="generalArray"
                            :domainPreferred="[reportData.actionPreferred, reportData.attentionPreferred, reportData.operatingPreferred]"
                        />
                        <!-- <div class="chart-text" v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_GRAPH_EXPLAINER`))"></div> -->
                        <div class="profile-chart-text">
                            <h2>
                                <span>{{ reportData.actionPreferred }}</span>
                                <span class="text-grey">in</span>
                                <span>{{ reportData.operatingPreferred }}</span>
                                <span>{{ reportData.attentionPreferred }}</span>
                            </h2>
                            <div class="profile-chart-icons">
                                <img :src="`/images/design/cta/${reportData.actionPreferred}.svg`" />
                                <span class="profile-chart-icon-stub" aria-hidden="true"></span>
                                <img :src="`/images/design/cta/${reportData.operatingPreferred}.svg`" />
                                <img :src="`/images/design/cta/${reportData.attentionPreferred}.svg`" />
                            </div>

                            <div class="child">
                                {{ $t(`reportsWeb.PROFILE_TEXT_${profileKey}_TEXT`) }}
                            </div>
                        </div>
                    </div>
                </div>

                <h3>{{ $t(`reportsWeb.PROFILE_BRIEF`) }}</h3>

                <div class="table-container">
                    <table class="cta-table-extended">
                        <thead>
                            <tr>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_1`) }}</th>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_2`) }}</th>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_3`) }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TEXT_${profileKey}_KEY_STRENGTHS`))"></td>
                                <td v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TEXT_${profileKey}_POTENTIAL_CHALLENGES`))"></td>
                                <td v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TEXT_${profileKey}_ACTIONABLE_INSIGHTS`))"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TEXT_DEBRIEF_OUTRO`))"></div>

                <!-- <div class="table-container">
                    <table class="cta-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_1`) }}</th>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_2`) }}</th>
                                <th>{{ $t(`reportsWeb.PROFILE_TABLE_COL_HEADER_3`) }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th
                                    v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TABLE_ROW_HEADER_1`, { preferred: reportData.actionPreferred }))">
                                </th>
                                <td>{{ $t(`reportsWeb.PROFILE_TABLE_COL_1_${reportData.actionPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{ $t(`reportsWeb.PROFILE_TABLE_COL_2_${reportData.actionPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{ $t(`reportsWeb.PROFILE_TABLE_COL_3_${reportData.actionPreferred.toUpperCase()}`)
                                }}</td>
                            </tr>
                            <tr>
                                <th
                                    v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TABLE_ROW_HEADER_2`, { preferred: reportData.operatingPreferred }))">
                                </th>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_1_${reportData.operatingPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_2_${reportData.operatingPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_3_${reportData.operatingPreferred.toUpperCase()}`)
                                }}</td>
                            </tr>
                            <tr>
                                <th
                                    v-html="sanitizeHtml($t(`reportsWeb.PROFILE_TABLE_ROW_HEADER_3`, { preferred: reportData.attentionPreferred }))">
                                </th>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_1_${reportData.attentionPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_2_${reportData.attentionPreferred.toUpperCase()}`)
                                }}</td>
                                <td>{{
                                    $t(`reportsWeb.PROFILE_TABLE_COL_3_${reportData.attentionPreferred.toUpperCase()}`)
                                }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
                <!-- <h3 class="paragraph-header">{{ $t('reportsWeb.PROFILE_DEBRIEF_TITLE') }}</h3>
                <div v-html="sanitizeHtml($t(`reportsWeb.PROFILE_DEBRIEF_TEXT`))"></div> -->
            </div>
        </page>
        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.UNDERSTANDING_TITLE') }}</survey-title>
                <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_TEXT`))"></div>
                <div class="chart-wrapper" style="margin-top: 2rem">
                    <CtaSunburstChart
                        :chartId="99"
                        :domainArray="generalArray"
                        :domainPreferred="[reportData.actionPreferred, reportData.attentionPreferred, reportData.operatingPreferred]"
                    />
                    <div class="chart-text">
                        <div class="chart-text-understanding">
                            <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_CHART_EXPLAINER`))"></div>
                        </div>
                    </div>
                </div>
                <h3 class="paragraph-header">{{ $t('reportsWeb.UNDERSTANDING_GENERAL_TITLE') }}</h3>
                <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_GENERAL_EXPLAINER`))"></div>
            </div>
        </page>

        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.ACTION_DOMAIN_TITLE') }}</survey-title>
                <div class="chart-wrapper">
                    <CtaSunburstChart
                        :chartId="1"
                        class="action-domain-chart"
                        :domainArray="actionDomainArray"
                        :domainPreferred="[reportData.actionPreferred]"
                    />
                    <div class="chart-text">
                        <div class="chart-text-action-domain">
                            <p>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER`) }}</p>
                            <div class="d-flex align-items-center justify-content-center">
                                <p>
                                    <b>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_DEFAULT_TENDENCY_CALCULATED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.actionPreferred}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.actionPreferred }}</h2>
                            </div>
                            <p>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_2`) }}</p>
                            <div>
                                <p>
                                    <b>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_PREFERRED_PROPENSITY_REPORTED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.actionReported}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.actionReported }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="extended-action-domain-wrapper">
                <div class="domain-item">
                    <img src="/images/design/cta/Move.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_MOVE`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Oppose.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_OPPOSE`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Follow.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_FOLLOW`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Bystand.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_BYSTAND`))"></div>
                </div>
            </div>
        </page>
        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.OPPERATING_DOMAIN_TITLE') }}</survey-title>
                <div class="chart-wrapper">
                    <CtaSunburstChart
                        :chartId="2"
                        class="operating-domain-chart"
                        :domainArray="operatingDomainArray"
                        :domainPreferred="[reportData.operatingPreferred]"
                    />
                    <div class="chart-text">
                        <div class="chart-text-action-domain">
                            <p>{{ $t(`reportsWeb.OPERATING_DOMAIN_CHART_EXPLAINER`) }}</p>
                            <div class="d-flex align-items-center justify-content-center">
                                <p>
                                    <b>{{ $t(`reportsWeb.OPERATING_DOMAIN_CHART_EXPLAINER_DEFAULT_TENDENCY_CALCULATED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.operatingPreferred}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.operatingPreferred }}</h2>
                            </div>
                            <p>{{ $t(`reportsWeb.OPERATING_DOMAIN_CHART_EXPLAINER_2`) }}</p>
                            <div>
                                <p>
                                    <b>{{ $t(`reportsWeb.OPERATING_DOMAIN_CHART_EXPLAINER_PREFERRED_PROPENSITY_REPORTED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.operatingReported}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.operatingReported }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="extended-operating-domain-wrapper">
                <div class="domain-item">
                    <img src="/images/design/cta/Closed.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.OPERATING_DOMAIN_CLOSED`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Open.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.OPERATING_DOMAIN_OPEN`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Random.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.OPERATING_DOMAIN_RANDOM`))"></div>
                </div>
            </div>
        </page>
        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.ATTENTION_DOMAIN_TITLE') }}</survey-title>
                <div class="chart-wrapper">
                    <CtaSunburstChart
                        :chartId="3"
                        class="attention-domain-chart"
                        :domainArray="attentionDomainArray"
                        :domainPreferred="[reportData.attentionPreferred]"
                    />
                    <div class="chart-text">
                        <div class="chart-text-action-domain">
                            <p>{{ $t(`reportsWeb.ATTENTION_DOMAIN_CHART_EXPLAINER`) }}</p>
                            <div class="d-flex align-items-center justify-content-center">
                                <p>
                                    <b>{{ $t(`reportsWeb.ATTENTION_DOMAIN_CHART_EXPLAINER_DEFAULT_TENDENCY_CALCULATED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.attentionPreferred}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.attentionPreferred }}</h2>
                            </div>
                            <p>{{ $t(`reportsWeb.ATTENTION_DOMAIN_CHART_EXPLAINER_2`) }}</p>
                            <div>
                                <p>
                                    <b>{{ $t(`reportsWeb.ATTENTION_DOMAIN_CHART_EXPLAINER_PREFERRED_PROPENSITY_REPORTED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.attentionReported}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                />
                                <h2>{{ reportData.attentionReported }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="extended-attention-domain-wrapper">
                <div class="domain-item">
                    <img src="/images/design/cta/Affect.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ATTENTION_DOMAIN_AFFECT`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Meaning.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ATTENTION_DOMAIN_MEANING`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Power.svg" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ATTENTION_DOMAIN_POWER`))"></div>
                </div>
            </div>
        </page>
        <page break-after>
            <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.IMPLICATIONS_TITLE') }}</survey-title>

            <h4 class="paragraph-sub-header">{{ $t('reportsWeb.IMPLICATIONS_COMMUNICATION_TITLE') }}</h4>
            <div v-html="sanitizeHtml($t(`reportsWeb.IMPLICATIONS_COMMUNICATION_EXPLAINER`))" />

            <h3 class="paragraph-sub-header">{{ $t('reportsWeb.IMPLICATIONS_CONTEXT_TITLE') }}</h3>
            <div v-html="sanitizeHtml($t(`reportsWeb.IMPLICATIONS_CONTEXT_EXPLAINER`))" />

            <h4 class="paragraph-sub-header">{{ $t('reportsWeb.IMPLICATIONS_STORY_TITLE') }}</h4>
            <div v-html="sanitizeHtml($t(`reportsWeb.IMPLICATIONS_STORY_EXPLAINER`))" />

            <!-- <h3 class="paragraph-sub-header">{{ $t('reportsWeb.IMPLICATIONS_APPROACHES_TITLE') }}</h3>
            <div v-html="sanitizeHtml($t(`reportsWeb.IMPLICATIONS_APPROACHES_EXPLAINER`))" /> -->

            <h3 class="paragraph-sub-header">{{ $t('reportsWeb.IMPLICATIONS_AWARENESS_TITLE') }}</h3>
            <div v-html="sanitizeHtml($t(`reportsWeb.IMPLICATIONS_AWARENESS_EXPLAINER`))" />
        </page>

        <page break-after>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div v-html="sanitizeHtml($t(`reportsWeb.REFERENCES_TEXT`))"></div>

            <hr class="divider" />

            <div v-html="sanitizeHtml($t(`reportsWeb.RECOMMENDED_READINGS`))"></div>
        </page>
    </report>
</template>
<script src="./CtaExtendedReport.ts" />
<style lang="scss">
body.rendering {
    .cta-chart-container {
        .cta-chart-export-image {
            display: block;
        }
    }

    .cta-summary {
        display: block;

        .cta-summary-pages {
            display: block;

            ul {
                list-style: none;
                padding-left: 3rem;
                padding-right: 3rem;
                margin-bottom: 2rem;

                li {
                    max-width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.2rem;

                    h3 {
                        margin: 0;
                    }

                    span {
                        font-weight: bold;
                    }
                }
            }
        }
    }
}

body:not(.rendering) {
    .cta-summary {
        display: none;

        .cta-summary-pages {
            ul {
                list-style: none;
                padding-left: 3rem;
                padding-right: 3rem;
                margin-bottom: 2rem;

                li {
                    max-width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.2rem;

                    h3 {
                        margin: 0;
                    }

                    span {
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>
